export default "__VITE_ASSET__9hjm731X__"